import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Backdrop, CircularProgress } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 999999,
		color: '#fff',
	},
}));

const Loading = () => {
	const classes = useStyles();
	const isLoading = useSelector(state => state.session.isLoading);
	return (
		<Backdrop className={classes.backdrop} open={isLoading}>
			<CircularProgress />
		</Backdrop>
	);
};

export default Loading;
